module.exports = __webpack_public_path__ + "media/images/front/icons/drvideos-73e2bdef98d8234c9aa286998f628ffd.png";